$(document).on("click", ".mc-list", function (e) {
  e.cancelBubble = true;
  e.stopPropagation();
  const index = $(e.currentTarget).data("index");
  const dataContainer = $(`.mc-data[data-index='${index}']`)[0];

  $(dataContainer).attr("open", true);
  $(dataContainer).removeAttr("hidden");
});

$(document).on("click", ".mc-data-header", function (e) {
  e.cancelBubble = true;
  e.stopPropagation();

  const index = $(e.currentTarget)
    .children(".mc-data-back")
    .first()
    .data("index");
  const dataContainer = $(`.mc-data[data-index='${index}']`)[0];

  $(dataContainer).removeAttr("open");
  $(dataContainer).attr("hidden", true);
});

$(document).on("click", ".mc-has-child", function (e) {
  e.cancelBubble = true;
  e.stopPropagation();
  const index = $(this).data("index");
  $(this).find(".mc-data-opener").first().toggleClass("mc-active");
  const dataContainer = $(`.mc-data-child[data-index='${index}']`);

  $(dataContainer).toggleClass("mc-data-active");
});

$(document).on("click", "#signature-box", function () {
  const elValue = $("textarea[is='cart-note']").first().val();
  if ($(this).prop("checked") == true) {
    if (!elValue.includes("Signature on delivery")) {
      $("textarea[is='cart-note']")
        .first()
        .val(elValue + "Signature on delivery");
    }
  } else if ($(this).prop("checked") == false) {
    $("textarea[is='cart-note']")
      .first()
      .val(elValue.replace("Signature on delivery", ""));
  }
});

document.addEventListener("cart:updated", function (event) {
  var cart = event.detail.cart;
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
  setTimeout(function () {
  }, 1000);
});
